import { Injectable } from '@angular/core';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';

@Injectable()
export class SpecialtiesService extends UserService{

  constructor(
    protected requestService: RequestService,
    protected auth: Auth
  ) { super(requestService, auth); }

  protected getUsersUrl(): string {

    return 'specialties';
  };

  protected getOneUserUrl(): string {

    return 'specialty';
  };

  protected parseObject(obj: any): any {

    return obj as any;
  };

  protected parseArray(objs: any): any[] {

    return objs as any[];
  };

  public createSpecialty(localizedName, localizedDegree, hexaColor): Promise<any> {
    return this.requestService.makeRequest({
      body: {
        localizedName: JSON.stringify(localizedName),
        localizedDegree: JSON.stringify(localizedDegree),
        hexaColor
      },
      method: 'post'
    }, '/specialty')
    .then((response: any) => {
      return response._body;
    });

  }

  public getOne(id:string): Promise<any> {
    return this.requestService.makeRequest({
      method: 'get'
    }, '/specialty/' + id)
    .then((response: any) => {
      return response._body;
    })
  }


  public getAll(): Promise<any> {
    return this.requestService.makeRequest({
      method: 'get',
      urlQueryParams: {limit:1000}
    }, '/specialty')
    .then((response: any) => {
      return response._body;
    })
  }

  public update(id, body): Promise<any> {
    return this.requestService.makeRequest({
      method: 'put',
      body: body
    }, '/specialty/' + id)
    .then((response: any) => {
      return response._body;
    })
  }

  public editImages(id, body): Promise<any> {
    return this.requestService.makeRequestImageWithEndpoint({
      method: 'put',
      body: body
    }, '/specialty/' + id + "/editImage")
    .then((response: any) => {
      return response._body;
    })
  }

  public setMedikitIDs(body): Promise<any> {
    return this.requestService.makeRequestImage({
      method: 'put',
      body: body,
      urlKey: 'setMedikitIds'
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/services/specialties/specialties.service.ts